import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'checkboxIcon',
  props: {
  colorBackground: {
    type: String as PropType<string>,
    default: "#D9EDE2",
  },
  colorCheckbox: {
    type: String as PropType<string>,
    default: "#01893D",
  },
  size: {
    type: Number as PropType<number>,
    default: 14,
  },
  hidePath: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none"
  }, [
    _createElementVNode("circle", {
      cx: "7",
      cy: "7",
      r: "7",
      fill: __props.colorBackground
    }, null, 8, _hoisted_2),
    (__props.hidePath)
      ? (_openBlock(), _createElementBlock("path", {
          key: 0,
          d: "M5.60453 8.71772L4.00003 7.1854L3 8.15235L5.60673 10.57L11 4.76783L9.99076 3.80078L5.60453 8.71772Z",
          fill: __props.colorCheckbox
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})